import { useState } from "react";
import { Link } from "react-router-dom";
import {
  BarChartIcon,
  BasketIcon,
  DocumentIcon,
  DropdownIcon,
  LineChartIcon,
  MultiUsersIcon,
  RightArrowIcon,
  RupeeIcon,
  SolarShareIcon,
  UserOnboardIcon,
  VerifyCheckIcon,
} from "./Icons";
import { optionsData } from "./utils";

const MobileScreen = () => {
  const [selectedOption, setSelectedOption] = useState(
    "Registered Investment Advisor",
  );

  const [openDropdown, setOpenDropdown] = useState(false);

  return (
    <div className="bg-[#000] relative block lg:hidden">
      <div className="p-4  w-full self-stretch h-[700px] inline-flex flex-col justify-center items-center gap-8">
        <div className="self-stretch flex flex-col justify-start items-center gap-5">
          <div className="px-3 py-2.5 bg-[#222222]/40 rounded-[100px] backdrop-blur-[20px] inline-flex justify-center items-center gap-2">
            <VerifyCheckIcon width={20} height={20} />
            <div className="text-center text-neutral-100 text-sm">
              Simplify. Streamline. Succeed
            </div>
          </div>
          <div className="self-stretch text-center justify-start text-white text-[32px] font-medium  leading-[51.20px]">
            One Platform to Power
            <br />
            Your Entire Wealth Business
          </div>
          <div className="self-stretch text-center justify-start text-[#9aa4b2] text-xs font-normal  leading-snug">
            Designed for Family Offices, Financial Advisors, Portfolio Managers,
            Brokers, and Wealth Businesses seeking to manage and scale their
            business.
          </div>
        </div>
        <div className="self-stretch flex flex-col justify-center items-center gap-4">
          <Link
            className="w-40 px-6 py-4 bg-gradient-to-r from-[#006580] via-[#107281] to-[#4ca485] rounded-sm flex justify-center items-center gap-2 cursor-pointer"
            to="/dashboard"
          >
            <div className="text-white text-sm font-medium">Get Started</div>
            <div className="size-4 relative">
              <RightArrowIcon width={20} height={20} />
            </div>
          </Link>
          <Link
            to="https://calendly.com/gridkey/introduction-to-gridkey-platform?month=2024-01"
            target="_blank"
            data-property-1="Default"
            className="w-40 px-6 py-4 rounded-sm  outline-1 outline-offset-[-1px] outline-white inline-flex justify-center items-center gap-2 overflow-hidden cursor-pointer"
          >
            <div className="justify-start text-white text-sm font-medium font-['Inter']">
              Request a Demo
            </div>
          </Link>
        </div>
      </div>
      <div className="p-4 w-full self-stretch py-10 inline-flex flex-col justify-start items-center gap-8">
        <div className="self-stretch relative flex flex-col justify-start items-center gap-4">
          <div
            data-dropdown="false"
            data-property-1="Default"
            className="size- px-4 py-2.5 rounded-lg outline-1 outline-offset-[-1px] outline-[#828282] inline-flex justify-center items-center gap-2"
          >
            <div className="text-center justify-start text-[#bdbdbd] text-[10px] font-medium  uppercase leading-none tracking-widest">
              tech tools
            </div>
          </div>
          <div className="self-stretch text-center justify-start text-[#006580] text-[32px] font-medium  leading-[44.80px]">
            Your Back-Office,
            <br />
            Mid-Office & Front-Office, Digitized.{" "}
          </div>
          <div className="self-stretch text-center justify-start text-[#828282] text-sm font-normal  leading-snug">
            Your clients don’t invest in silos, why should your tools?
          </div>
          <div className="w-[308px] h-[300px] left-[26px] top-[-26px] absolute opacity-20 bg-linear-52 from-[#006580] via-[#107281] via 40% to-[#4ca485] blur-[100px]" />
        </div>
        <div className="size- flex flex-col justify-start items-center gap-3">
          {[
            {
              name: "Streamlined Fee Tracking",
              icon: RupeeIcon,
              iconSize: 20,
              size: 12,
            },
            {
              name: "Data-Driven Insights & Analytics",
              icon: LineChartIcon,
              iconSize: 20,
              size: 14,
            },
            {
              name: "Intuitive Lead Handling",
              icon: MultiUsersIcon,
              iconSize: 20,
              size: 16,
            },
            {
              name: "Comprehensive Client Reporting",
              icon: DocumentIcon,
              iconSize: 24,
              size: 18,
            },
            {
              name: "Smooth Client Onboarding",
              icon: UserOnboardIcon,
              iconSize: 40,
              size: 24,
            },
            {
              name: "Seamless Portfolio Management",
              icon: BarChartIcon,
              iconSize: 24,
              size: 18,
            },
            {
              name: "Scalable Partner Ecosystem",
              icon: SolarShareIcon,
              iconSize: 20,
              size: 16,
            },
            {
              name: "Effortless Compliance",
              icon: VerifyCheckIcon,
              iconSize: 20,
              size: 14,
            },
            {
              name: "Frictionless Order Execution",
              icon: BasketIcon,
              size: 12,
              iconSize: 20,
            },
          ].map((_, i) => {
            return (
              <div
                key={i}
                className="size- p-3 bg-[#222222] rounded-[91.67px] inline-flex justify-start items-center gap-2"
              >
                <_.icon
                  style={{
                    minHeight: 24,
                    minWidth: 24,
                  }}
                  height={24}
                  width={24}
                />
                <p
                  className={`text-white font-bold`}
                  style={{
                    fontSize: _.size,
                  }}
                >
                  {_.name}
                </p>
              </div>
            );
          })}
        </div>
      </div>
      <div className="p-4 w-full self-stretch py-10 inline-flex flex-col justify-start items-center gap-8">
        <div className="self-stretch relative flex flex-col justify-start items-center gap-4">
          <div
            data-dropdown="false"
            data-property-1="Default"
            className="size- px-4 py-2.5 rounded-lg outline-1 outline-offset-[-1px] outline-[#828282] inline-flex justify-center items-center gap-2"
          >
            <div className="text-center justify-start text-[#bdbdbd] text-[10px] font-medium  uppercase leading-none tracking-widest">
              Financial assets
            </div>
          </div>
          <div className="self-stretch text-center justify-start text-[#006580] text-[32px] font-medium  leading-[44.80px]">
            Integrated Holistic
            <br />
            Portfolio Management Starts Here
          </div>
          <div className="self-stretch text-center justify-start text-[#828282] text-sm font-normal  leading-snug">
            Our intuitive app simplifies tracking and managing diverse financial
            assets.
          </div>
          <div className="w-[308px] h-[300px] left-[29px] top-[-26px] absolute opacity-20 bg-linear-52 from-[#006580] via-[#107281] via 40% to-[#4ca485] blur-[100px]" />
        </div>
        <div className="size- flex flex-col justify-start items-center gap-3">
          {[
            {
              name: "Streamlined Fee Tracking",
              icon: RupeeIcon,
              iconSize: 20,
              size: 12,
            },
            {
              name: "Data-Driven Insights & Analytics",
              icon: LineChartIcon,
              iconSize: 20,
              size: 14,
            },
            {
              name: "Intuitive Lead Handling",
              icon: MultiUsersIcon,
              iconSize: 20,
              size: 16,
            },
            {
              name: "Comprehensive Client Reporting",
              icon: DocumentIcon,
              iconSize: 24,
              size: 18,
            },
            {
              name: "Smooth Client Onboarding",
              icon: UserOnboardIcon,
              iconSize: 40,
              size: 24,
            },
            {
              name: "Seamless Portfolio Management",
              icon: BarChartIcon,
              iconSize: 24,
              size: 18,
            },
            {
              name: "Scalable Partner Ecosystem",
              icon: SolarShareIcon,
              iconSize: 20,
              size: 16,
            },
            {
              name: "Effortless Compliance",
              icon: VerifyCheckIcon,
              iconSize: 20,
              size: 14,
            },
            {
              name: "Frictionless Order Execution",
              icon: BasketIcon,
              size: 12,
              iconSize: 20,
            },
          ].map((_, i) => {
            return (
              <div
                key={i}
                className="size- p-3 bg-[#222222] rounded-[91.67px] inline-flex justify-start items-center gap-2"
              >
                <_.icon
                  style={{
                    minHeight: 24,
                    minWidth: 24,
                  }}
                  height={24}
                  width={24}
                />
                <p
                  className={`text-white font-bold`}
                  style={{
                    fontSize: _.size,
                  }}
                >
                  {_.name}
                </p>
              </div>
            );
          })}
        </div>
      </div>
      <div className="p-4 w-full self-stretch py-10 inline-flex flex-col justify-start items-center gap-8">
        <div className="self-stretch text-center justify-start text-[#006580] text-[40px] font-medium  leading-[52px]">
          One Platform,
          <br />
          Many Solutions!
        </div>
        <div className="self-stretch flex flex-col justify-start items-center gap-4">
          <div className="justify-start text-white text-lg font-medium  uppercase">
            I’m a...
          </div>
          <div className="w-full relative">
            <button
              type="button"
              onClick={() => setOpenDropdown(!openDropdown)}
              data-property-1="Selected"
              className="w-full px-4 py-3 bg-[#111111] rounded-xl  outline-1 outline-offset-[-1px] outline-[#006580] inline-flex justify-start items-center gap-4 "
              aria-haspopup="listbox"
              aria-expanded={openDropdown}
            >
              <div className="flex-1 justify-start text-[#e0e0e0] text-sm font-medium  uppercase tracking-wider">
                {selectedOption}
              </div>
              <div className="size-5 inline-flex flex-col justify-center items-center gap-2.5">
                <DropdownIcon
                  color="transparent"
                  style={{
                    minHeight: 14,
                    minWidth: 14,
                  }}
                />
              </div>
            </button>
            {openDropdown && (
              <div
                className="absolute mt-2 w-full bg-[#1a1a1a] rounded-xl shadow-lg border border-[#00658022] z-10"
                role="listbox"
              >
                {optionsData.map((option) => (
                  <button
                    type="button"
                    key={option.name}
                    onClick={() => {
                      setSelectedOption(option.name);
                      setOpenDropdown(false);
                    }}
                    className="px-4 py-2 text-sm text-[#e0e0e0] hover:bg-[#006580] hover:text-white cursor-pointer rounded-lg"
                    role="option"
                    aria-selected={
                      selectedOption === option.name ? "true" : "false"
                    }
                  >
                    {option.name}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
        {optionsData
          .filter((opt) => opt.name === selectedOption)
          .map((opt) => {
            return (
              <section
                key={opt.name}
                className="flex flex-col items-center w-full "
              >
                <div className="w-full flex justify-center flex-col items-center">
                  <div className="self-stretch text-[#ececec] text-2xl md:text-[40px] font-medium leading-[1.3] md:leading-[52px] text-center">
                    {opt.title}
                  </div>
                  <ol className="self-stretch text-[#828282] text-base md:text-xl font-normal leading-loose list-disc list-outside mt-4 md:ml-6 ml-4">
                    {opt.descriptions.map((desc, index) => (
                      <li key={index} className="text-[14px]">
                        {desc}
                      </li>
                    ))}
                  </ol>
                </div>
                <div className="w-full flex justify-center items-center">
                  <img
                    src={opt.imgSrc}
                    alt=""
                    className="w-3/4 md:w-1/2 h-auto"
                  />
                </div>
              </section>
            );
          })}
      </div>
      <div className="p-4 w-full self-stretch py-[200px] inline-flex flex-col justify-start items-center gap-5">
        <div className="self-stretch relative flex flex-col justify-start items-center gap-4">
          <div className="size-[361px] left-0 top-[-90.21px] absolute opacity-50 bg-linear-52 from-[#006580] via-[#107281] via 40% to-[#4ca485] rounded-full blur-[200px]" />
          <div className="self-stretch text-center justify-start text-white text-[32px] font-medium ">
            Why Choose us?
          </div>
          <div className="self-stretch text-center justify-start text-[#e0e0e0] text-sm font-normal  leading-[25.20px]">
            Advisory runs on trust. Our platform helps you deliver personal
            experiences, build client confidence, and turn complexity into
            lasting growth. With every feature designed for clarity and ease,
            you stay focused on what matters most: your clients.
          </div>
        </div>
      </div>
      <div className="p-4 w-full px-4 py-10 relative bg-white inline-flex flex-col justify-start items-start overflow-hidden">
        <div className="w-[393px] h-[649px] left-0 top-[45.79px] absolute  z-0 overflow-hidden">
          <div className="w-0 h-[365.90px] left-[-10.84px] top-0 absolute outline-[0.68px] outline-offset-[-0.34px] outline-[#e6f0f3]" />
          <div className="w-0 h-[393px] left-[393px] top-[119.79px] absolute origin-top-left rotate-90 outline-[0.68px] outline-offset-[-0.34px] outline-[#e6f0f3]" />
          <div className="w-0 h-[417.39px] left-[417.39px] top-[258.16px] absolute origin-top-left rotate-90 outline-[0.68px] outline-offset-[-0.34px] outline-[#e6f0f3]" />
          <div className="w-0 h-[417.39px] left-[417.39px] top-[189.05px] absolute origin-top-left rotate-90 outline-[0.68px] outline-offset-[-0.34px] outline-[#e6f0f3]" />
          <div className="w-0 h-[417.39px] left-[417.39px] top-[327.27px] absolute origin-top-left rotate-90 outline-[0.68px] outline-offset-[-0.34px] outline-[#e6f0f3]" />
          <div className="w-0 h-[417.39px] left-[417.39px] top-[465.50px] absolute origin-top-left rotate-90 outline-[0.68px] outline-offset-[-0.34px] outline-[#e6f0f3]" />
          <div className="w-0 h-[417.39px] left-[417.39px] top-[534.61px] absolute origin-top-left rotate-90 outline-[0.68px] outline-offset-[-0.34px] outline-[#e6f0f3]" />
          <div className="w-0 h-[417.39px] left-[417.39px] top-[396.39px] absolute origin-top-left rotate-90 outline-[0.68px] outline-offset-[-0.34px] outline-[#e6f0f3]" />
          <div className="w-0 h-[609.83px] left-[138.91px] top-0 absolute outline-[0.68px] outline-offset-[-0.34px] outline-[#e6f0f3]" />
          <div className="w-0 h-[609.83px] left-[69.79px] top-0 absolute outline-[0.68px] outline-offset-[-0.34px] outline-[#e6f0f3]" />
          <div className="w-0 h-[609.83px] left-[208.02px] top-0 absolute outline-[0.68px] outline-offset-[-0.34px] outline-[#e6f0f3]" />
          <div className="w-0 h-[609.83px] left-[346.25px] top-0 absolute outline-[0.68px] outline-offset-[-0.34px] outline-[#e6f0f3]" />
          <div className="w-0 h-[609.83px] left-[277.13px] top-0 absolute outline-[0.68px] outline-offset-[-0.34px] outline-[#e6f0f3]" />
          <div className="size-1 left-[275.50px] top-[117.91px] absolute bg-[#006580] rounded-full" />
          <div className="size-1 left-[136.50px] top-[255.91px] absolute bg-[#006580] rounded-full" />
          <div className="size-1 left-[275.50px] top-[393.91px] absolute bg-[#006580] rounded-full" />
          <div className="size-1 left-[276.50px] top-[256.91px] absolute opacity-0 bg-[#006580] rounded-full" />
          <div className="size-1 left-[137.50px] top-[117.91px] absolute opacity-0 bg-[#338499] rounded-full" />
          <div className="size-1 left-[137.50px] top-[394.91px] absolute opacity-0 bg-[#338499] rounded-full" />
        </div>
        <div className="self-stretch flex flex-col justify-start items-center gap-8 z-10">
          <div className="self-stretch text-center justify-start text-[#006580] text-[32px] font-semibold  leading-[41.60px]">
            Built on trust.
            <br />
            Driven by insight.
            <br />
            Made for you.
          </div>
          <div className="self-stretch flex flex-col justify-start items-start gap-12">
            {[
              {
                title: "Founder’s Vision",
                description:
                  "Industry experts with a vision to revolutionize wealth management space.",
                icon: SolarShareIcon,
              },
              {
                title: "Client-Centric Approach",
                description:
                  "We ensure that every feature is designed to meet the unique needs of our users.",
                icon: SolarShareIcon,
              },
              {
                title: "Holistic Wealth Management",
                description:
                  "Gridkey covers every aspect of wealth management in one integrated platform.",
                icon: SolarShareIcon,
              },
              {
                title: "Intuitive Tools",
                description:
                  "Leverage cutting-edge tools for growing your advisory business.",
                icon: SolarShareIcon,
              },
              {
                title: "Data Driven Insights",
                description:
                  "Make informed decision with insights and reports, empowering you to stay ahead in the game",
                icon: SolarShareIcon,
              },
              {
                title: "Innovation at Core",
                description:
                  "We continuosly strive to bring innovative solutions to simpliy complex financial landscape.",
                icon: SolarShareIcon,
              },
            ].map((dataItem, index) => {
              return (
                <div
                  key={index}
                  className="self-stretch rounded-[10.84px] flex flex-col justify-start items-center"
                >
                  <dataItem.icon />
                  <div className="self-stretch flex flex-col justify-start items-start gap-[2.71px]">
                    <div className="self-stretch text-center justify-start text-[#333333] text-base font-semibold  leading-tight">
                      {dataItem?.title}
                    </div>
                    <div className="self-stretch text-center justify-start text-[#4f4f4f] text-sm font-medium  leading-snug">
                      {dataItem?.description}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="p-4 w-full  px-4 py-10 relative bg-white inline-flex flex-col justify-start items-start overflow-hidden">
        <div className="self-stretch flex flex-col justify-start items-start gap-4">
          <img className="w-[91px] h-[100px]" src="./security1.svg" alt="" />
          <div className="w-full flex flex-col justify-start items-start gap-2">
            <div className="self-stretch justify-start text-[#006580] text-[32px] font-semibold  leading-[41.60px]">
              Security Built Into Every Layer
            </div>
            <div className="self-stretch justify-start text-[#333333] text-xs font-normal  leading-tight">
              Where regulatory compliance, client trust, and business growth
              align seamlessly through technology.
            </div>
          </div>
          <div className="self-stretch flex flex-col justify-start items-start gap-12">
            {[
              {
                title: "Cloud-based platform",
                description:
                  "Access your wealth management tools securely from anywhere.",
                icon: "",
              },
              {
                title: "Cutting-edge web security",
                description:
                  "AI-powered monitoring and firewalls protect your data from threats.",
                icon: "",
              },
              {
                title: "Secure 256-bit SSL for max safety",
                description:
                  "Industry-leading encryption keeps transactions and client information safe.",
                icon: "",
              },
            ].map((dataItem, index) => {
              return (
                <div
                  key={index}
                  className="w-[269px] rounded-[10.84px] flex flex-col justify-start items-start"
                >
                  <img src="/security1.svg" alt="" height={24} width={24} />
                  <div className="self-stretch flex flex-col justify-start items-center gap-[2.71px]">
                    <div className="self-stretch justify-start text-[#333333] text-base font-semibold  leading-tight">
                      {dataItem.title}
                    </div>
                    <div className="self-stretch justify-start text-[#4f4f4f] text-sm font-medium  leading-snug">
                      {dataItem.description}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileScreen;
